module.exports = __webpack_public_path__ + "img/hr-profile.cb39fc14.svg";